var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadow1Bg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1112,
    height: 1053,
    viewBox: "0 0 1112 1053",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M811.999 559.106C766.385 622.754 713.201 673.88 657.571 707.559C601.941 741.238 545.739 756.335 494.381 751.395C443.023 746.455 398.24 721.645 364.345 679.355C330.451 637.066 308.588 578.721 300.863 509.943L623.461 300.249L811.999 559.106Z",
    fill: "#2F8C26",
    fillOpacity: 0.12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_196",
    x: 0.862686,
    y: 0.24939,
    width: 1111.14,
    height: 1052.06,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_1_196"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow1Bg);
export default __webpack_public_path__ + "static/media/shadow1bg.20c6f686236c687283bf2fba5bc1aa27.svg";
export { ForwardRef as ReactComponent };